import React from 'react';
import { Text } from 'base-components';

const Emphasis = (
  <Text modifiers="fontWeightMedium" style={{ display: 'inline' }} />
);

export default Emphasis;



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/Contacts/DeleteContactModal/Emphasis.js